interface HeaderValidationResult {
  valid: boolean;
  errors: string[];
}

export const validateHeaders = (headers: string[]): HeaderValidationResult => {
  const errors: string[] = [];

  if (headers.length === 0) {
    errors.push(
      'No column headers were found. Please select a row with column names.'
    );
    return {
      valid: false,
      errors,
    };
  }

  const { emptyCount, duplicates } = headers.reduce(
    (acc, header) => {
      if (!header || !header.trim()) {
        acc.emptyCount += 1;
        return acc;
      }

      const normalized = header.trim().toLowerCase();
      const existing = acc.seen.get(normalized);

      if (existing) {
        acc.duplicates.add(existing);
      } else {
        acc.seen.set(normalized, header);
      }

      return acc;
    },
    {
      emptyCount: 0,
      seen: new Map<string, string>(),
      duplicates: new Set<string>(),
    }
  );

  const nonEmptyHeaders = headers.filter((h) => h && h.trim());
  if (nonEmptyHeaders.length === 0) {
    errors.push(
      'No column headers were found. Please select a row with column names.'
    );
  }

  if (emptyCount > 0) {
    errors.push(
      `${emptyCount} column${emptyCount > 1 ? 's have' : ' has'} empty or blank header names. Please remove or rename them.`
    );
  }

  if (duplicates.size > 0) {
    const names = Array.from(duplicates).join(', ');
    errors.push(
      `Duplicate column names found: ${names}. Each column must have a unique name.`
    );
  }

  return {
    valid: errors.length === 0,
    errors,
  };
};
